function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function renderMessage() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var paragraphs = String(message).split(/\n+/).map(function (line) {
    return line.trim();
  }).filter(Boolean);
  if (!paragraphs.length) {
    return '';
  }
  return paragraphs.map(function (line) {
    return "<p>".concat(escapeHtml(line), "</p>");
  }).join('\n    ');
}
function renderProviders() {
  var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return providers.map(function (provider) {
    var id = escapeHtml(provider.id || '');
    var name = escapeHtml(provider.name || provider.id || 'Continue');
    var icon = escapeHtml(provider.icon || '');
    var iconHtml = icon ? "<i class=\"".concat(icon, "\" aria-hidden=\"true\"></i>") : '';
    return "\n    <button type=\"button\" class=\"saito-button-primary\" data-auth-provider=\"".concat(id, "\">\n      ").concat(iconHtml, "\n      Continue with ").concat(name, "\n    </button>");
  }).join('');
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Welcome to Saito' : _ref$title,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? '' : _ref$message,
    _ref$providers = _ref.providers,
    providers = _ref$providers === void 0 ? [] : _ref$providers;
  var safeTitle = escapeHtml(title);
  var body = renderMessage(message);
  var actions = renderProviders(providers);
  return "\n<div class=\"auth\">\n  <header class=\"saito-overlay-form-header\">\n    <h2 class=\"saito-overlay-form-header-title\">".concat(safeTitle, "</h2>\n  </header>\n\n  <div class=\"body\">\n    ").concat(body, "\n  </div>\n\n  <div class=\"actions\">\n    ").concat(actions, "\n    <button type=\"button\" class=\"saito-button-secondary\" data-auth-cancel>\n      Cancel\n    </button>\n  </div>\n</div>\n");
};